import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { Utility } from '../../helpers/utility';
import { SecurityConfigService } from '../security-config.service';
import { AuthEventService, authEventNames } from './auth.events.service';

const IdTokenKey = 'okta_token_key';
const AccessTokenKey = 'okta_access_token_key';
declare let OktaSignIn: any;

@Injectable()
export class OktaService {
  private oktaSignIn;

  constructor(private config: SecurityConfigService, private authEvent: AuthEventService) {
     this.oktaSignIn = new OktaSignIn(this.config.OktaConfig);

    this.oktaSignIn.tokenManager.on('expired', (key, expiredToken) => {
      // console.log('OktaService event expired', {key, expiredToken});
      this.authEvent.raise(authEventNames.AUTH_EVENT_TOKEN_EXPIRED, expiredToken);
    });

    this.oktaSignIn.tokenManager.on('error', function (err) {
      // console.log('OktaService event error', {err});
      this.authEvent.raise(authEventNames.AUTH_EVENT_TOKEN_ERROR, err);
    });

    this.oktaSignIn.tokenManager.on('refreshed', (key, newToken, oldToken) => {
      // console.log('OktaService event refreshed', {key, newToken, oldToken});
      this.authEvent.raise(authEventNames.AUTH_EVENT_TOKEN_REFRESHED, newToken);
    });
  }


  getWidget() {
    return this.oktaSignIn;
  }

  addToken(token) {
    this.oktaSignIn.tokenManager.add(IdTokenKey, token);
  }

  refreshToken() {
    return this.oktaSignIn.tokenManager.refresh(IdTokenKey);
  }

  getToken() {
    return this.oktaSignIn.tokenManager.get(IdTokenKey);
  }

  removeToken() {
    this.oktaSignIn.tokenManager.remove(IdTokenKey);
  }

  addAccessToken(token) {
    this.oktaSignIn.tokenManager.add(AccessTokenKey, token);
  }

  getAccessToken() {
    return this.oktaSignIn.tokenManager.get(AccessTokenKey);
  }

  removeAccessToken() {
    this.oktaSignIn.tokenManager.remove(AccessTokenKey);
  }

  signOut(callback: () => void) {
    this.oktaSignIn.signOut(callback);
  }

  checkSession(): Observable<any> {
    const pr = Utility.promiseFactory<any>();

    this.oktaSignIn.session.get((session) => {
      if (session.status && session.status !== 'INACTIVE') {
        pr.resolve(session);
      }
      pr.resolve(null);
    });

    return Observable.fromPromise(pr.promise);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/security/services/okta.service.ts